<template>
  <section class="register">
    <div class="box">
      <div class="header">
        <div class="title">Cancelar Evento</div>
        <div @click="close" class="close"><i class="fas fa-times"></i></div>
      </div>
      <form @submit.prevent="cancelEvent" class="form">
        <label class="pay-label">Evento</label>
        <div class="pay-value">{{ show.name }}</div>
        <label class="pay-label">Data</label>
        <div class="pay-value">{{ show.date }}</div>
        <label class="pay-label">Motivo</label>
        <textarea v-model="reason" rows="3" :class="{ error : error.indexOf('reason') > -1 }" />
        <div v-if="error.indexOf('reason') > -1" class="hint">você esqueceu o motivo</div>
        <div v-if="errorMsg" class="hint">{{ errorMsg }}</div>
        <button type="submit" class="button-save" style="margin-top: 30px"><i class="fas" :class="loading ? 'fa-spinner loading' : 'fa-check'"></i><span>Confirmar</span></button>
      </form>
    </div>
  </section>
</template>

<script>
import logger from '../../logger'
import { cancel } from '../api/showDate'

export default {
  name: 'ShowCancel',
  props: ['show', 'close'],
  data () {
    return {
      loading: false,
      error: [],
      errorMsg: null,
      reason: null,
      response: null
    }
  },
  methods: {
    async cancelEvent () {
      try {
        this.loading = true
        this.error = []
        this.errorMsg = null
        await cancel(this.show.id, this.reason)
        this.$message.success('O evento foi cancelado', { duration: 3000 })
        this.close()
        this.$router.push('/event')
        setTimeout(() => {
          this.loading = false
          this.$router.go()
        }, 500)
      } catch (error) {
        const data = error.response ? error.response.data : {}
        // Validation error
        if (data.error === 'Validation error') {
          this.error = data.fields
        } else {
          this.errorMsg = 'Erro interno! Tente novamente.'
          logger.error(error)
        }
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../_asset/scss/_variables";

.pay-label {
  color: $primary-color;
  font-weight: 500;
  font-size: 0.85em;
}

.pay-value {
  margin-top: 3px;
  color: #777;
  max-height: 100px;
  overflow-y: auto;
}
.selector_change {
    background-color: #cccccc;
    color: #595959;
    font-size: 0.8em;
    padding: 2.5px;
}
</style>
